"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ui = require("@probeton/ui");

var _pocUi = require("@solar/poc-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ManufacturerSheet = function ManufacturerSheet(_ref) {
  var manufacturer = _ref.manufacturer,
      loading = _ref.loading,
      handleUserClick = _ref.handleUserClick,
      handleUnitClick = _ref.handleUnitClick,
      handleOnboarding = _ref.handleOnboarding,
      history = _ref.history,
      action = _ref.action,
      labels = _ref.labels;
  var name = manufacturer.name,
      cover = manufacturer.cover;
  var tabs = {
    info: {
      label: labels.tabs.info,
      component: /*#__PURE__*/_react["default"].createElement(_ui.ManufacturerInfo, {
        manufacturer: manufacturer,
        onUserClick: handleUserClick,
        onUnitClick: handleUnitClick,
        onStartOnboarding: handleOnboarding,
        loading: loading
      })
    },
    contacts: {
      label: labels.tabs.contacts,
      component: /*#__PURE__*/_react["default"].createElement(_ui.ContactsInfo, {
        contacts: manufacturer.contacts || []
      })
    },
    certificates: {
      label: labels.tabs.certificates,
      component: /*#__PURE__*/_react["default"].createElement(_ui.CertificateList, {
        certificates: manufacturer.certificates || [],
        manufacturer: manufacturer,
        openCertificate: function openCertificate(certificateId) {
          return history.push("/certificates/".concat(certificateId));
        },
        hideOwner: true,
        labels: labels
      })
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_pocUi.CoverTabView, {
    title: name,
    cover: cover && cover.src,
    tabs: tabs,
    action: action
  });
};

var _default = ManufacturerSheet;
exports["default"] = _default;